/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignScrape } from '../../axios/campaignScrape'
import type { CampaignScrapeError, CampaignScrapeRequest, CampaignScrapeResponse } from '../../types/CampaignScrape'

export const campaignScrapeMutationKey = () => [{ url: '/campaigns/scrape' }] as const

export type CampaignScrapeMutationKey = ReturnType<typeof campaignScrapeMutationKey>

export type CampaignScrapeVariables = {
	data: CampaignScrapeRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::scrape */
export function useCampaignScrape<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignScrapeResponse,
		AxiosError<CampaignScrapeError>,
		CampaignScrapeVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignScrapeMutationKey(),
		mutationFn: ({ data }: CampaignScrapeVariables) => campaignScrape(data, config).then(res => res.data),
		...options,
	})
}
